const DUPLICATE_EMAIL_MESSAGE =
  "This email address is already in use. Please try another email or log in.";

const INTERNAL_ERROR_MESSAGE =
  "We could not complete registration. Please try again or contact support.";

function extractApiErrorMessage(error: unknown): string {
  if (typeof error === "string") {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (error && typeof error === "object") {
    const o = error as Record<string, unknown>;
    const msg = o.message;
    if (typeof msg === "string") {
      return msg;
    }
    if (Array.isArray(msg)) {
      return msg.filter((x): x is string => typeof x === "string").join(" ");
    }
    if (typeof o.error === "string") {
      return o.error;
    }
  }
  return "";
}

function isDuplicateEmailError(text: string): boolean {
  const lower = text.toLowerCase();
  if (!lower.includes("e11000") && !lower.includes("duplicate key")) {
    return false;
  }
  return (
    lower.includes("email") ||
    lower.includes("email_1") ||
    /dup key:\s*\{\s*email:/i.test(text)
  );
}

function looksLikeLeakedDbError(text: string): boolean {
  const lower = text.toLowerCase();
  return (
    lower.includes("e11000") ||
    lower.includes("mongoservererror") ||
    lower.includes("collection:") ||
    /\bindex:\s*\w+_1\b/i.test(text)
  );
}

/** Maps API / DB errors from register to user-facing copy (axios interceptor passes `response.data`). */
export function getRegisterFailureMessage(error: unknown): string {
  const raw = extractApiErrorMessage(error).trim();
  if (!raw) {
    return "Failed to register. Please try again.";
  }
  if (isDuplicateEmailError(raw)) {
    return DUPLICATE_EMAIL_MESSAGE;
  }
  if (looksLikeLeakedDbError(raw)) {
    return INTERNAL_ERROR_MESSAGE;
  }
  return raw;
}
